import React from 'react'
import { Link } from 'react-router-dom'

const Logout = () => {
  return (
    <div>
    
    <Link to='/'>
    <button>Go to login page</button>
    </Link>
    </div>
  )
}

export default Logout